<template>
  <div class="modal-content-virtual-member">
    <div class="modal-header">
      <h2>Kreiranje novog korisnika</h2>
    </div>
    <div class="body">
      <div id="first-section">
        <div class="member-input__profile-pic text-center">
          <picture-upload
            :height="'120px'"
            :width="'120px'"
            :text="'Profilna slika'"
            :icon="'far fa-user'"
            :circleBorder="true"
            @removedUploadedImg="uploadedFile = null"
            @fileAttached="handleFileUpload"
          ></picture-upload>
        </div>

        <label class="col-form-label col-form-label-lg">
          Prezime i ime
          <span class="mandatory">*</span>
        </label>
        <input
          class="form-control"
          rows="4"
          placeholder="Unesite prezime i ime"
          v-model.trim="name"
          @focus="errorOccurred = false"
        />

        <label class="col-form-label col-form-label-lg">
          Rola
          <span class="mandatory">*</span>
        </label>
        <select
          class="form-control custom-select"
          id="selecCategory"
          v-model="userRole"
        >
          <option value="MANAGER">Upravnik</option>
          <option value="SUPER_MANAGER">Superupravnik</option>
          >
        </select>

        <label class="col-form-label col-form-label-lg">
          Broj telefona
        </label>
        <input
          class="form-control"
          rows="4"
          placeholder="Unesite broj telefona"
          v-model.trim="phone"
          @focus="errorOccurred = false"
        />
        <label class="col-form-label col-form-label-lg">
          Email
          <span class="mandatory">*</span>
        </label>
        <input
          class="form-control"
          rows="4"
          placeholder="Unesite email"
          v-model.trim="email"
          @focus="errorOccurred = false"
        />
        <label class="col-form-label col-form-label-lg">
          Šifra
          <span class="mandatory">*</span>
        </label>
        <input
          class="form-control"
          type="password"
          rows="4"
          placeholder="Unesite šifru"
          v-model.trim="password"
          @focus="errorOccurred = false"
        />
        <label class="col-form-label col-form-label-lg">
          Ponovite šifru
          <span class="mandatory">*</span>
        </label>
        <input
          class="form-control"
          type="password"
          rows="4"
          placeholder="Ponovo unesite šifru"
          v-model.trim="passwordRepeat"
          @focus="errorOccurred = false"
        />
      </div>
    </div>

    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>

      <div class="buttons" style="text-align:center">
        <button
          type="submit"
          class="btn btn-danger btn--mod"
          @click="closeModal"
        >
          Otkaži
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          :disabled="loading"
          @click="addUser"
        >
          <p v-if="!loading">Dodaj novog korisnika</p>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import axios from '@/axios/axios.js';
import { utilService } from '@/util/UtilService.js';
import debounce from 'debounce';
import pictureUpload from '@/components/community/PictureUploadPreview';

export default {
  components: {
    pictureUpload: pictureUpload
  },
  data() {
    return {
      errorOccurred: false,
      errorMessage: '',
      loading: false,
      name: '',
      phone: '',
      email: '',
      password: '',
      passwordRepeat: '',
      uploadedFile: null,
      userRole: 'MANAGER'
    };
  },
  async created() {
    //
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    ...mapMutations('table', ['setTableData']),
    ...mapActions('table', ['getAllMembersForCommunityFinances']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapMutations('finances', ['setVirtualMembersList']),
    ...mapActions('table', ['getAllUsers']),

    handleFileUpload(file) {
      this.uploadedFile = file.file;
    },
    formatMediaForSubmit() {
      let fd = new FormData();
      fd.append('files[]', this.uploadedFile, this.uploadedFile.name);
      fd.append('type', 'community');
      fd.append('community_id', '');
      return fd;
    },
    async addUser() {
      this.errorOccurred = false;
      if (!this.validateInput()) {
        this.errorOccurred = true;
        return;
      }
      this.loading = true;
      // TODO: Pass company id when got on login
      try {
        if (this.uploadedFile) {
          const result = await axios.post(
            'media/add',
            this.formatMediaForSubmit(),
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          );
          this.registerUser(result.data.ids[0]);
        } else {
          this.registerUser();
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.showFailModal();
      }
    },
    async registerUser(mediaId = '') {
      try {
        const data = {
          email: this.email,
          password: this.password,
          fullName: this.name,
          phoneNumber: this.phone,
          role: this.userRole
        };
        if (mediaId != '') {
          data.mediaId = mediaId;
        }
        await axios.post('company/user', data);
        await this.getAllUsers(this.$store.getters.getUser.id);
        this.closeModal();
        this.showSuccessModal();
      } catch (error) {
        console.log(error.response.data);
        this.loading = false;
        if (error.response.data.messages) {
          this.showFailModal(error.response.data.messages);
        } else {
          this.showFailModal();
        }
      }
    },
    validateInput() {
      if (this.name.trim() == '') {
        this.errorMessage = 'Morate uneti prezime i ime korisnika';
        return false;
      }
      if (this.email.trim() == '') {
        this.errorMessage = 'Morate uneti email korisnika';
        return false;
      }
      if (!utilService.isEmailValid(this.email)) {
        this.errorMessage = 'Morate uneti validnu email adresu';
        return false;
      }
      if (this.password.trim() == '') {
        this.errorMessage = 'Morate uneti šifru';
        return false;
      }
      if (this.password.trim().length < 6) {
        this.errorMessage = 'Šifra mora imati bar 6 karaktera';
        return false;
      }
      if (this.password != this.passwordRepeat) {
        this.errorMessage = 'Unete šifre moraju biti isti';
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss">
.member-input__profile-pic {
  margin-top: 8px;
}
.user--mod {
  .text {
    max-width: calc(100% - 30px) !important;
  }
}
.address-search {
  height: calc(2.25rem + 5px) !important;
  input {
    font-size: 1rem !important;
  }
  item {
    font-size: 1rem !important;
  }
}
.list-no-border {
  border: none !important;
}
.modal-content-virtual-member {
  .add-new-contact {
    margin-left: 0 !important;
    // margin-top: 16px;
  }
  .contacts {
    padding: 8px;
    border: 1px solid var(--primary-color);
    border-radius: 4px;
    margin-bottom: 16px;
    span.btn-primary {
      width: 4rem;
      min-width: 25px;
    }
  }
  .address-wrapper {
    display: flex;
    .address-street {
      flex: 3;
    }
    .address-number {
      flex: 1;
      margin-left: 16px;
      input {
        height: calc(2.25rem + 5px) !important;
      }
    }
    .first-item {
      flex: 1;
    }
    .second-item {
      flex: 1;
      margin-left: 16px;
    }
  }
  .input-wrapper {
    display: flex;
    width: 100%;
    position: relative;
    .user--mod {
      width: 100%;
      z-index: 5;
      margin-bottom: 2rem;
      input {
        margin-bottom: 0;
      }
      .address-search {
        width: 100%;
        line-height: 1.5;
        border-radius: 0.3rem;
        border: 1px solid #ced4da;
        font-size: 1rem;
        color: #495057;
        transition: 0.2s all;
        height: calc(2.25rem + 2px);

        // input {
        //   border: none;
        //   padding: 0.5rem 1rem;
        //   font-size: 1rem;
        //   line-height: 1;
        //   max-width: 100%;
        // }

        input:focus {
          border: none;
          outline: none;
          & {
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
        .text {
          position: absolute;
          top: 7px;
          left: 1rem;
          color: #5f5f5f;
          font-size: 1rem;
        }
        .menu {
          border: 1px solid #ced4da;
          border-radius: 0.3rem;
          border-top-width: 0;
          border-top-right-radius: 0;
          border-top-left-radius: 0;
          z-index: 11;
          background-color: white;
          max-height: 10rem;
          overflow-y: auto;
          margin: -5px -1px 0px -1px;
          .item {
            z-index: 15;
          }
          .item:hover {
            background-color: rgba(0, 0, 0, 0.05);
            cursor: pointer;
          }

          .item.selected {
            background-color: rgba(0, 0, 0, 0.178);
          }

          .btn--add {
            width: 100%;
          }
        }
      }
    }
    .add-member-dropdown {
      .menu {
        max-height: 10rem !important;
      }
    }

    .amount--mod {
      width: 100%;
      margin-bottom: 2rem;
    }

    .input-span {
      position: absolute;
      font-size: 1.5rem;
      color: rgb(95, 95, 95);
      top: 0.5rem;
      pointer-events: none;
      transition: 0.2s all;
      left: 1rem;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input {
      margin-right: 15px;
    }

    .input--:focus ~ .input-span--name,
    .input--name:not(:placeholder-shown) ~ .input-span--name {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
      // opacity: 0;
    }

    .input--amount:focus ~ .input-span--amount,
    .input--amount:not(:placeholder-shown) ~ .input-span--amount {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
    }

    .relative {
      position: relative;
    }
  }

  .body {
    height: 100%;
    width: 100%;
  }

  input {
    margin-bottom: 9px;
    position: relative;
  }

  .btn-add-desc {
    i {
      margin-left: 4px;
    }
  }

  .desc-wrapper {
    display: flex;
    justify-content: space-between;
    span {
      margin-bottom: 9px;
      margin-left: 8px;
      min-width: 60px;
    }
  }

  .footer {
    display: block;
    width: 100%;
    text-align: center;
  }

  .buttons {
    display: inline-flex;
    float: right;
  }

  .btn--mod {
    margin-left: 15px;
  }

  .btn-primary:hover {
    background-color: var(--primary-color-lighten);
  }

  .btn-primary:active {
    background-color: var(--primary-color) !important;
    border: none;
  }

  .btn-primary:focus {
    box-shadow: 0 0 0 0.2rem var(--primary-color-lighten) !important;
  }

  .error {
    float: left;
    margin-left: 15px;
  }

  .err-msg {
    text-align: center;
    color: red;
  }

  .col-form-label-lg {
    width: 100%;
    position: relative;
  }

  .mandatory {
    color: red;
  }

  label.tooltip-label {
    display: flex;
    .mandatory {
      margin-left: 4px;
    }
    .popover {
      position: relative;
      width: fit-content;
      border: none;
      padding: 4px 4px 2px 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 1.1rem;
        color: var(--primary-color);
      }
    }
  }
}
</style>
